export {
  CrewJoinType,
  CrewMembershipStatus,
  CrewRole,
  ExpeditionKind,
  ExpeditionStatus,
} from "../../graphql/generated";

import type {
  ExpeditionBySlugQuery,
  ExpeditionExpensesListQuery,
  ExpeditionsListQuery,
  LogbookEntriesQuery,
} from "../../graphql/generated";

export type ExpeditionListItem = ExpeditionsListQuery["expeditions"][number];
export type ExpeditionDetailData = NonNullable<ExpeditionBySlugQuery["expeditionBySlug"]>;
export type ExpeditionCrewMember = ExpeditionDetailData["crew"][number];
export type ExpeditionVesselAssignment = ExpeditionDetailData["vessels"][number];
export type ExpeditionRoute = NonNullable<ExpeditionDetailData["route"]>;
export type ExpeditionExpense = ExpeditionExpensesListQuery["expenses"][number];
export type LogbookEntry = LogbookEntriesQuery["logbookEntries"][number];

// ── List page ─────────────────────────────────────────────────────────────────

export const LIST_TAB_FILTERS = ["all", "active", "open", "planning", "completed", "cancelled"] as const;
export type ListTabFilter = (typeof LIST_TAB_FILTERS)[number];

// ── Detail page ───────────────────────────────────────────────────────────────

export type DetailTabValue = "overview" | "route" | "crew" | "expenses" | "documents" | "log";
